import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-students-branch',
  templateUrl: './students-branch.component.html',
  styleUrls: ['./students-branch.component.scss']
})
export class StudentsBranchComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
